module.exports = __webpack_public_path__ + "img/image2.e6c14f25.jpg";